<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/Text/Covenant_with_Hell2#Contents-A">Dedication</a></p>
<p class="Body-Center-Italic">In memory of Edmund M. Kaufman, a man of wit and grace, who gave so many of us a place to be heard.</p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Covenant_with_Hell-3.vue?0196aeb6